import styled from 'styled-components';
import { CaptionText as CaptionTextComponent } from '@prisjakt/ui/text/variants';
import { media, layout } from '@prisjakt/ui-base';

export const ShowOnMediumUp = styled.span`
  padding-right: ${layout.measurements.spacingTiny};
  ${media.smallOnly`
      display:none;
    `}
`;

export const CaptionText = styled(CaptionTextComponent)`
  white-space: nowrap;
`;
